export default __webpack_public_path__ + "static/VP_Hero-75c2be9808a18f404140163cdb42e4f5.mp4";